import {type ParserT, array, record} from '@freckle/parser'
import {
  parseDehydratedDomainAttrs,
  type DehydratedRlDomainT
} from '@freckle/student-entities/ts/common/models/rl-domain'
import {
  parseDehydratedStandard,
  type DehydratedRlStandardT
} from '@freckle/student-entities/ts/common/models/rl-standard'

export type DehydratedRlDomainStandardT = {
  domain: DehydratedRlDomainT
  standards: Array<DehydratedRlStandardT>
}

export const parseDehydrated: ParserT<DehydratedRlDomainStandardT> = record({
  domain: parseDehydratedDomainAttrs,
  standards: array(parseDehydratedStandard)
})
